const initState = {}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'ON_LOAD_ACCOUNT':
            return { ...state, account: action.payload }

        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/settingAccountReducer.js